import { Progress } from 'antd';
import { isMobileOnly } from 'react-device-detect';

const ProgressBySteps = ({ steps, stage }) => {
	return (
		<div
			className="Progress-by-steps"
			style={{ justifyContent: 'left', marginLeft: isMobileOnly ? 16 : 12 }}>
			<div className="steps-and-title">
				<div style={{ display: 'flex' }}>
					<div
						className="title-by-steps"
						style={{
							fontWeight: 600,
							fontSize: 14,
							lineHeight: '24px'
						}}>
						Paso {stage}
					</div>
					<div
						className="title-by-steps"
						style={{
							fontWeight: 400,
							marginLeft: 4
						}}>
						de {steps}
					</div>
				</div>
				<Progress
					className={isMobileOnly ? 'steps-mobile' : 'steps-desktop'}
					percent={(stage * 100) / steps}
					steps={steps}
					showInfo={false}
					strokeColor={'#006DFF'}
					trailColor={'#E0E0E0'}
					strokeWidth={4}
				/>
			</div>
		</div>
	);
};

export default ProgressBySteps;
